export default __webpack_public_path__ + "tab3_videoed0edb.mp4";